import styled from 'styled-components';
export const StackContent = styled.div `
    display: grid;
    gap: var(--Stack_Gap, 0.75rem);
`;
